import { render, staticRenderFns } from "./FeedbackCallForm.vue?vue&type=template&id=0ec743ba&"
import script from "./FeedbackCallForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackCallForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports